import React from 'react';
import {Switch} from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import Ambulance from './ambulance';
import AmbulanceDetail from './ambulance-detail';
import AmbulanceUpdate from './ambulance-update';

const Routes = ({match}) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={AmbulanceUpdate}/>
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={AmbulanceUpdate}/>
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={AmbulanceDetail}/>
      <ErrorBoundaryRoute path={match.url} component={Ambulance}/>
    </Switch>
  </>
);

export default Routes;
